import { Component, Input } from '@angular/core';
import { DiffContextService } from '../diff-context.service';

@Component({
  selector: 'diff-comments',
  template: require('./diff-comments.component.html')
})
export class DiffCommentsComponent {
  @Input() diff: any;
  @Input() rowidx: number;
  @Input() comments: any[];
  @Input() detailLevel: number;
  index: number;

  constructor(private diffContextService: DiffContextService) {}

  getContextLines(): any[] {
    return this.diffContextService.getContextLines(this.diff, this.rowidx);
  }

  shouldShowContext(comment: any): boolean {
    return this.diffContextService.shouldShowContext(this.diff, this.rowidx, comment);
  }
}
